import { render } from "./Description.vue?vue&type=template&id=ffc43260"
const script = {}
script.render = render

export default script